import { ConnectedAccountKybStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const connectedAccountsKybStatusMapping = {
    [ConnectedAccountKybStatus.Active]: 'success',
    [ConnectedAccountKybStatus.ActionRequired]: 'warning',
    [ConnectedAccountKybStatus.Pending]: 'info',
    [ConnectedAccountKybStatus.Submitted]: 'secondary',
    [ConnectedAccountKybStatus.Suspended]: 'error',
    [ConnectedAccountKybStatus.Disabled]: 'warning',
} as { [key in ConnectedAccountKybStatus]: EnumColor };
